export default {
      id: "profile-support-usage",
      viewBox: "0 0 24 30",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#profile-support",
      toString: function () {
        return this.url;
      }
    }